

export default {
  releaseVersionDoc: 'https://bugly.tds.tencent.com/docs/tutorial/others/openapi/#docusaurus_skipToContent_fallback',
};
